import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useBrand } from "../context/BrandContext";
import { useLang } from "../context/LanguageContext";

export function BrandLogo({ light = false }) {
  const s = useBrand();
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <div className="grid place-items-center rounded-xl overflow-hidden h-10 w-10 ring-1 ring-black/5 bg-white">
        <img src="/trisha-logo.jpeg" alt={s.business_name} className="h-full w-full object-cover" />
      </div>
      <div className="leading-tight">
        <div className={`font-heading font-extrabold text-[15px] ${light ? "text-white" : "text-navy"}`}>
          {s.business_name}
        </div>
        <div className={`text-[10px] tracking-[0.18em] uppercase ${light ? "text-white/60" : "text-slate-400"}`}>
          {s.product_name}
        </div>
      </div>
    </div>
  );
}

export function LanguageSwitcher() {
  const { lang, setLang } = useLang();
  const opts = [["en", "EN"], ["hi", "हिं"], ["mr", "मरा"], ["gu", "ગુજ"]];
  return (
    <div data-testid="lang-toggle" className="flex rounded-full border border-slate-200 bg-white p-0.5">
      {opts.map(([k, label]) => (
        <button key={k} data-testid={`lang-${k}`} onClick={() => setLang(k)}
          className={`rounded-full px-2.5 py-1 text-xs font-semibold transition-colors duration-200 ${lang === k ? "bg-navy text-white" : "text-slate-500 hover:text-navy"}`}>
          {label}
        </button>
      ))}
    </div>
  );
}

export function SiteHeader() {
  const navigate = useNavigate();
  const { t } = useLang();
  return (
    <header className="sticky top-0 z-40 bg-white/85 backdrop-blur-md border-b border-slate-200">
      <div className="max-w-6xl mx-auto px-5 h-16 flex items-center justify-between">
        <Link to="/"><BrandLogo /></Link>
        <div className="flex items-center gap-2">
          <LanguageSwitcher />
          <button
            data-testid="header-start-btn"
            onClick={() => navigate("/assessment")}
            className="rounded-full bg-gold text-navy font-heading font-semibold text-sm px-5 py-2.5 hover:-translate-y-0.5 hover:shadow-md transition-transform duration-300"
          >
            {t("start_checkup")}
          </button>
        </div>
      </div>
    </header>
  );
}

export function SiteFooter() {
  const s = useBrand();
  return (
    <footer className="brand-gradient text-white mt-24">
      <div className="max-w-6xl mx-auto px-5 py-14 grid md:grid-cols-3 gap-10">
        <div>
          <BrandLogo light />
          <p className="mt-4 text-white/70 text-sm leading-relaxed max-w-xs">{s.secondary_tagline}</p>
        </div>
        <div className="text-sm">
          <div className="font-heading font-semibold mb-3 text-gold">Contact</div>
          <ul className="space-y-2 text-white/75">
            {s.advisor_name && <li>{s.advisor_name}</li>}
            {s.email && <li>{s.email}</li>}
            {s.website && <li>{s.website}</li>}
            {s.mobile && <li>Mobile: {s.mobile}</li>}
          </ul>
        </div>
        <div className="text-sm">
          <div className="font-heading font-semibold mb-3 text-gold">Legal</div>
          <ul className="space-y-2 text-white/75">
            <li><a href="/privacy" className="hover:text-white transition-colors duration-200">Privacy Policy</a></li>
            <li><a href="/admin/login" className="hover:text-white transition-colors duration-200">Advisor Login</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-6xl mx-auto px-5 py-5 text-xs text-white/50">
          {s.disclaimer || "This tool provides general educational information only and does not constitute investment, insurance or tax advice."}
        </div>
      </div>
    </footer>
  );
}
